const loadGoogleMapsApi = require('load-google-maps-api')

loadGoogleMapsApi({
    key: "AIzaSyD3Y2wS2o4j9Ma5f3ZCRKfX0Sda0hpmSvQ"
}).then(function (googleMaps) {
    console.log(googleMaps)
    let el = document.querySelector('.map')
    let center = new googleMaps.LatLng(25.0100717,121.48379580000005);
    let mapProps = {
        center: center,
        zoom: 17,
        scrollwheel: false,
        draggable: false
}
    let map = new googleMaps.Map(el, mapProps)
    let marker = new googleMaps.Marker({
        position: center,
        map: map
})
}).catch(function (error) {
    console.error(error)
})

// function myMap() {
//   var myCenter = new google.maps.LatLng(24.9982805, 121.4857076);
//   var mapProp = {
//     center: myCenter,
//     zoom: 19,
//     scrollwheel: false,
//     draggable: false,
//     mapTypeId: google.maps.MapTypeId.ROADMAP
//   };
//   var map = new google.maps.Map(document.getElementById("Map"), mapProp);
//   var marker = new google.maps.Marker({
//     position: myCenter
//   });
//   marker.setMap(map);
// }



// WEBPACK FOOTER //
// ./src/maps.js